import './App.css';
import { useEffect, Suspense } from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import PortfolioNavbar from './components/Navbar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import { LazySkills, LazyProjects, LazyContact, preloadComponents, preloadOnInteraction } from './utils/lazyLoad';
import { initGA, trackPageView } from './utils/analytics';
import { throttle } from './utils/performance';
import { immediatePreload, preloadOnScroll } from './utils/intersectionPreloader';

function App() {
  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname);
    immediatePreload();
    preloadComponents();
    preloadOnInteraction();
    const preloader = preloadOnScroll();

    const handleSmoothScroll = throttle((e) => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
        const targetId = e.target.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          window.scrollTo({ top: target.offsetTop - 60, behavior: 'smooth' });
        }
      }
    }, 100);

    document.addEventListener('click', handleSmoothScroll, { passive: false });
    return () => {
      preloader.disconnect();
      document.removeEventListener('click', handleSmoothScroll);
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="app">
        <PortfolioNavbar />
        <main>
          <Hero />
          <Suspense fallback={<LoadingSpinner />}>
            <LazySkills />
            <LazyProjects />
            <LazyContact />
          </Suspense>
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
